require('jquery-ajax-transport-xdomainrequest');
require('suggestions-jquery');

// TODO: Учитывать поля только в пределах формы
$(document).ready(function(){
    $('input[name=full_name]').suggestions({
        token: process.env.MIX_DADATA_APP_KEY,
        type: "NAME",
        count: 5,
        scrollOnFocus: false,
        /* Вызывается, когда пользователь выбирает одну из подсказок */
        onSelect: function(suggestion) {
            $("input[name=first_name]").val(suggestion.data.name);
            $("input[name=last_name]").val(suggestion.data.surname);
            $("input[name=middle_name]").val(suggestion.data.patronymic);
            $("input[name=gender]").val(suggestion.data.gender);
        }
    });
});